import React from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
  MainPage,
  TeaserPage,
  PageTitle,
  EntainPattern,
} from "src/library/components/exports";
import { TEASER_SITE_ENABLED } from "src/library/constants";
import { RoutingIDEnum } from "src/library/types/types";
import { zIndexes } from "src/library/styles/theme";
import CONTENT from "src/library/content.json";

export default function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    pageTitles: { home, teaserHome },
  } = CONTENT;

  return (
    <Box sx={{ pt: isMobile ? "50px" : 0 }} id={RoutingIDEnum.Home} component="main">
      <PageTitle
        title={TEASER_SITE_ENABLED ? teaserHome : home}
        style={{ zIndex: zIndexes.Above }}
      />
      {TEASER_SITE_ENABLED ? <TeaserPage /> : <MainPage />}
      <EntainPattern />
    </Box>
  );
}
